import React, { Component } from 'react';
import { Message, Dimmer, Loader, Button, Grid, Divider, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import {
    getSystemAdminUserDetail,
    submitSystemAdminCreateAdmin,
    submitSystemAdminUpdateUser,
    submitSystemAdminUpdateAdmin,
    getBankOptions
} from '../../actions';
import CommonUtility from '../../utils/CommonUtility';
import { USER_TYPE } from '../../constants';
import UserFormNavigation from '../../component/sysadmin/user/user_form/user_form_navigation';
import AdminFormBasicInformation from '../../component/sysadmin/admin/admin_form_basic_information';
import UserFormLoginInformation from '../../component/sysadmin/user/user_form/user_form_login_information';
import UserFormBankDetail from '../../component/sysadmin/user/user_form/user_form_bank_detail';
import UserFormCompanies from '../../component/sysadmin/user/user_form/user_form_companies';
import UserFormStudent from '../../component/sysadmin/user/user_form/user_form_student';
import { Route, Switch, Link } from 'react-router-dom';

class SysadminAdminUpdatePage extends Component {
    state = {
        userDetail: this.props.userDetail,
        userCreatedId: null,
        successSubmit: null,
        successMsg: '',
        errorMsg: '',
    }

    componentDidMount() {
        // Get bank data        
        if (this.props.appConfig.bankList && !this.props.appConfig.bankList.blV2) {
            this.props.getBankOptions()
        }

        // Get user ID
        const queryString = new URLSearchParams(this.props.history.location.search);
        const userId = queryString.get("idUser");     
                  
        //   Get the user Audit
        let uuid=userId.split('?')
        // this.getUsers(uuid[0])  

        // Get user NRIC
        const nric = queryString.get("nric");

        // Set search filter
        let params = {}
        if (userId) params._id = userId;
        if (nric) params.nric = nric;

        const { accessToken } = this.props.user;

        // Get user
        this.props.getSystemAdminUserDetail( {accessToken, userId}, (result, error) => {
            if (result && result.data) {
                console.log("access here result data", result.data)
                if(result.data.user){
                    this.setState({ isLoading: false, userDetail: result.data.user,uuid:uuid[0] })
                }else{
                    this.setState({ isLoading: false, userDetail: null })
                }
            }
        })
    }

    clickBasicInformation() {
        this.setState(
            { ...this.state, successSubmit: undefined, errorMsg: '', successMsg: '' },
            this.props.history.push({ pathname: "/systemadmin/admin/create", search: this.props.history.location.search })
        );
    }

    renderSubmitResult() {
        if (this.state.successSubmit === true) {
            return (
                <Message positive>
                    <Message.Header>{this.state.successMsg || "Admin Created Successfully!"}</Message.Header>
                    <p>
                        <Link to={`/systemadmin/admin/update?idUser=${this.state.userCreatedId}`}>
                            Click here to view the user now!
                        </Link>
                    </p>
                </Message>
            );
        }
        if (this.state.successSubmit === false) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue</Message.Header>
                    <p>{this.state.errorMsg}</p>
                </Message>
            );
        }
    }


    onSubmitBasicInformation = (values, actions) => {

        this.setState({ ...this.state, successSubmit: undefined, successMsg: '', errorMsg: '', userCreatedId: null });

            // Prepare data to send 
            console.log(values)
            const roleList = [
                'ADMIN_OPERATION',
                'ADMIN_ACCOUNT',
                'ADMIN_CLAIM',
                'ADMIN_CALL_CENTRE',
                'ADMIN_IT',
                'ADMIN_CREATION'
            ]
            const roles = []
            roleList.map(role => {
                if(values[role]) {
                    roles.push({
                        type: role
                    })
                }
                return role;
            })

            let dataToSend = {
                accessToken: this.props.user.accessToken,
                userId: this.state.userDetail.uuid,
                data: {
                    userType: "sys-admin",
                    name: values.name,
                    nric: values.name,
                    email: values.email,
                    password: values.password,
                    roles: roles,
                }
            };

            console.log(dataToSend)

            // Create user
            this.props.submitSystemAdminUpdateAdmin(
                dataToSend,
                (result, error) => {
                    if (result) {
                        actions.setSubmitting(false);
                        actions.resetForm();
                        this.setState({ successSubmit: true, successMsg: '', errorMsg: '', userCreatedId: result.result.uuid });
                    }
                    if (error) {
                        actions.setSubmitting(false);
                        this.setState({ successSubmit: false, successMsg: '', errorMsg: error.errorMessage });
                    }
                }
            )

            this.props.history.push({ pathname: "/systemadmin/admin/list" })

    }

    render() {
        const admin = this.props.user;
        let queryString = new URLSearchParams(this.props.history.location.search);
        const clientId = queryString.get("idCompany");
        const client = _.find(this.props.clients, (client) => client._id === clientId);
        const isLoading = (this.props.appConfig.bankList && this.props.appConfig.bankList.blV2) ? false : true;
        console.log(this.state.userDetail)
        return (

            <Dimmer.Dimmable>
                <Dimmer active={isLoading} inverted>
                    <Loader />
                </Dimmer>
                {!isLoading &&
                    <React.Fragment>
                        <br />
                        <Grid centered > 
                            <Grid.Column width={14}>
                                <AdminFormBasicInformation
                                    user={this.state.userDetail}
                                    company={client}
                                    admin={admin}
                                    onSubmit={this.onSubmitBasicInformation.bind(this)}
                                    renderSubmitResult={this.renderSubmitResult.bind(this)}
                                    showDetail={false}
                                    clients={this.props.clients}
                                    submitText="Update User"
                                    users={this.props.user}
                                />
                            </Grid.Column>
                        </Grid>
                    </React.Fragment>
                }
            </Dimmer.Dimmable>

        );
    }
}

SysadminAdminUpdatePage.defaultProps = {
    userDetail: {
        companies: [],
        companyName: '',
        companyCode: '',
        name: '',
        nric: '',
        birthdate: '',
        gender: '',
        status: '',
        userType: '',
        designation: '',
        contactNo: '',
        contactNoCountryCode: '',
        mainTerms: '',
        subTerm1: '',
        subTerm2: '',
        planNo: '',
        costCenter: '',
        effectiveStartDate: '',
        effectiveEndDate: '',
        newNric: '',
        changeEffectiveDate: '',
        bankDetail: {
            bankName: '',
            bankNo: '',
            branchNo: '',
            accountNo: '',
        },
        email: '',
        costCenterName: '',
        loginRequired: 'Y',
        studentFullBankAccountNo: '',
        studentEmail: '',
        studentTel: '',
        studentCareerCode: '',
        studentMaritalStatus: '',
        studentID: '',
        studentNationality: '',
        singaporeCitizenshipstatus: '',
        nsMenIndicator: '',
        familyDetail: [],
    },
    company: null,
    allowEditBank: false,
    showProposedBankUI: false,
    admin: {},
    onCreateUser: undefined
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        clients: state.systemAdmin.clients,
        appConfig: state.appConfig
    }
};

export default connect(mapStateToProps, {
    getSystemAdminUserDetail,
    submitSystemAdminCreateAdmin,
    submitSystemAdminUpdateAdmin,
    getBankOptions
})(SysadminAdminUpdatePage)
